import { Box, Button, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { DashboardDetailEmptyState } from "web_myplann/Dashboard/Components/DashboardDetailEmptyState";
import { DashboardDetailSkeleton } from "web_myplann/Dashboard/Components/DashboardDetailSkeleton";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EmptyListSkeleton } from "web_myplann/Shared/Components/EmptyListSkeleton";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type Props = {
	isLoading: boolean;
	isError: boolean;
	onRetry: () => void;
};

export const DashboardDetailFallback: FC<Props> = ({
	isLoading,
	isError,
	onRetry,
}) => {
	const { t } = useResource();
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack minHeight="100dvh" bgcolor={palette.surface.muted}>
			<NavigationHeader
				title=""
				defaultRoute={Routing.Dashboard.path()}
				alwaysUseDefaultRoute
			/>
			{isLoading ? (
				<DashboardDetailSkeleton rowsPerCard={4} />
			) : isError ? (
				<Stack
					flex={1}
					justifyContent="center"
					pt={spacingTokens.sm}
					pb={spacingTokens.xl}
					gap={spacingTokens.lg}
				>
					<EmptyListSkeleton
						label={t(Resources.Dashboard.Detail.loadErrorTitle)}
						description={t(Resources.Dashboard.Detail.loadErrorDescription)}
						height="auto"
						skeletonSize="lg"
					/>
					<Box px={spacingTokens.lg}>
						<Button variant="secondary" onClick={() => onRetry()}>
							{t(Resources.Dashboard.Detail.retry)}
						</Button>
					</Box>
				</Stack>
			) : (
				<Stack
					flex={1}
					justifyContent="center"
					pt={spacingTokens.sm}
					pb={spacingTokens.xl}
				>
					<DashboardDetailEmptyState />
				</Stack>
			)}
		</Stack>
	);
};
